import React from "react";

export default function ManagementRecordsForm({ records, setRecords }) {
  return (
    <fieldset className="fra-fieldset">
      <legend>Management / Testing / Drill Records</legend>
      <div className="fra-form-group">
        <textarea
          value={records.logbook || ""}
          onChange={e => setRecords({ ...records, logbook: e.target.value })}
          placeholder="Describe fire logbook records and frequency..."
          rows={2}
        />
        <label>Fire Logbook Records</label>
      </div>
      <div className="fra-form-group">
        <textarea
          value={records.alarmTests || ""}
          onChange={e => setRecords({ ...records, alarmTests: e.target.value })}
          placeholder="Describe fire alarm tests and results..."
          rows={2}
        />
        <label>Fire Alarm Test Records</label>
      </div>
      <div className="fra-form-group">
        <textarea
          value={records.lightingTests || ""}
          onChange={e => setRecords({ ...records, lightingTests: e.target.value })}
          placeholder="Describe emergency lighting test records..."
          rows={2}
        />
        <label>Emergency Lighting Test Records</label>
      </div>
      <div className="fra-form-group">
        <textarea
          value={records.extinguisherTests || ""}
          onChange={e => setRecords({ ...records, extinguisherTests: e.target.value })}
          placeholder="Describe fire extinguisher maintenance..."
          rows={2}
        />
        <label>Extinguisher Maintenance Records</label>
      </div>
      <div className="fra-form-group">
        <textarea
          value={records.sprinklerTests || ""}
          onChange={e => setRecords({ ...records, sprinklerTests: e.target.value })}
          placeholder="Describe sprinkler system tests and results..."
          rows={2}
        />
        <label>Sprinkler System Test Records</label>
      </div>
      <div className="fra-form-group">
        <textarea
          value={records.liftTests || ""}
          onChange={e => setRecords({ ...records, liftTests: e.target.value })}
          placeholder="Describe evacuation/fire lift test records..."
          rows={2}
        />
        <label>Evacuation/Fire Lift Test Records</label>
      </div>
      <div className="fra-form-group">
        <textarea
          value={records.drills || ""}
          onChange={e => setRecords({ ...records, drills: e.target.value })}
          placeholder="Describe fire drill records, attendance, frequency..."
          rows={2}
        />
        <label>Fire Drill Records</label>
      </div>
      <div className="fra-form-group">
        <textarea
          value={records.lightningProtectionTests || ""}
          onChange={e => setRecords({ ...records, lightningProtectionTests: e.target.value })}
          placeholder="Describe lightning protection system test records..."
          rows={2}
        />
        <label>Lightning Protection Test Records</label>
      </div>
      <div className="fra-form-group">
        <textarea
          value={records.otherSystems || ""}
          onChange={e => setRecords({ ...records, otherSystems: e.target.value })}
          placeholder="Describe maintenance/testing of any other relevant systems..."
          rows={2}
        />
        <label>Other System Records</label>
      </div>
    </fieldset>
  );
}
